export const TP_TRIGGER_PRICE_TYPE = 'tp-trigger-price-type';
export const SL_TRIGGER_PRICE_TYPE = 'sl-trigger-price-type';

export const TRAILING_STOP_CREATE = /*            */ 0b01000001; // position 部分仓位创建
export const TRAILING_STOP_VIEW = /*              */ 0b01000010; // position 部分仓位列表
export const TRAILING_STOP_UPDATE = /*            */ 0b01000100; // position 部分仓位更新
export const TRAILING_STOP_MODIFY = /*            */ 0b01001000; // open order部分仓位修改
export const TRAILING_STOP_ENTIRE_CREATE = /*     */ 0b00010001; // position 整仓创建
export const TRAILING_STOP_ENTIRE_UPDATE = /*     */ 0b00010010; // position 整仓更新
export const TRAILING_STOP_ENTIRE_MODIFY = /*     */ 0b00010100; // open order整仓修改
export const PARTIALLY_CREATE = /*                */ 0b00100001;
export const PARTIALLY_VIEW = /*                  */ 0b00100010;
export const PARTIALLY_UPDATE = /*                */ 0b00100100;
export const ENTIRE_CREATE = /*                   */ 0b10001000;
export const ENTIRE_UPDATE = /*                   */ 0b10010000;

export const TRAILING_STOP_STATE =
  TRAILING_STOP_CREATE & TRAILING_STOP_VIEW & TRAILING_STOP_UPDATE & TRAILING_STOP_MODIFY;
export const TRAILING_STOP_ENTIRE_STATE =
  TRAILING_STOP_ENTIRE_CREATE & TRAILING_STOP_ENTIRE_UPDATE & TRAILING_STOP_ENTIRE_MODIFY;

export const PARTIALLY_STATE = PARTIALLY_CREATE & PARTIALLY_VIEW & PARTIALLY_UPDATE;
export const ENTIRE_STATE = ENTIRE_CREATE & ENTIRE_UPDATE;
